export const GENERAL_CODES = {
    G001: 'GENERAL_ERROR',
};
